import React from 'react';
import { motion } from 'framer-motion';
import ZUSPensionTracker from './ZUSPensionTracker';
import InvestmentPortfolio from './InvestmentPortfolio';
import { useGameStore } from '../store/gameStore';

const FinancialManagement: React.FC = () => {
  const { currentAge, money, status } = useGameStore();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50"
    >
      <div className="flex items-center space-x-3 mb-6">
        <div className="p-2 bg-gradient-to-r from-emerald-500 to-blue-500 rounded-xl">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
          </svg>
        </div>
        <div>
          <h3 className="text-xl font-bold text-white">Financial Management</h3>
          <p className="text-slate-400">Track your pension and investments</p>
        </div>
      </div>

      {/* Financial Management - Side by Side */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* ZUS Pension Tracker */}
        <ZUSPensionTracker
          currentAge={currentAge}
          monthlyIncome={status.monthlyIncome}
          isZusRegistered={status.isZusRegistered}
          yearsWorked={Math.max(0, currentAge - 18)}
          totalContributions={status.monthlyIncome * 0.1976 * Math.max(0, currentAge - 18) * 12}
          estimatedPension={status.monthlyIncome * 0.6}
          retirementAge={65}
        />

        {/* Investment Portfolio */}
        <InvestmentPortfolio
          totalSavings={money}
          currentInvestments={[]}
          onInvest={(investmentId, amount) => {
            // TODO: Implement investment logic
            console.log('Invest', investmentId, amount);
          }}
          onWithdraw={(investmentId, amount) => {
            // TODO: Implement withdrawal logic
            console.log('Withdraw', investmentId, amount);
          }}
        />
      </div>
    </motion.div>
  );
};

export default FinancialManagement;
